function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isFunction } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import { defaultInfoFormat } from './utils';
import Icon from '../icon';
import Props from './props';
import Circle from './circle';
export default {
  name: buildComponentName('Progress'),
  props: _objectSpread({}, Props, {
    prefixCls: {
      type: String,
      default: 'ux-progress'
    },
    type: {
      type: String,
      default: 'line',
      validator: function validator(val) {
        return ['line', 'circle', 'dashboard'].indexOf(val) > -1;
      }
    },
    format: {
      type: Function,
      default: null
    },
    status: {
      type: String,
      default: null,
      validator: function validator(val) {
        return ['default', 'success', 'error', 'active'].indexOf(val) > -1;
      }
    },
    hideInfo: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default',
      validator: function validator(val) {
        return ['default', 'small'].indexOf(val) > -1;
      }
    }
  }),
  computed: {
    validPercent: function validPercent() {
      var percentage = this.percentage;
      var percent = percentage;

      if (percent < 0) {
        percent = 0;
      } else if (percent > 100) {
        percent = 100;
      }

      return percent;
    },
    progressStatus: function progressStatus() {
      var validPercent = this.validPercent,
          status = this.status;
      var nStatus = status;

      if (nStatus === 'error') {
        nStatus = 'exception';
      } else if (nStatus === 'default') {
        nStatus = 'normal';
      }

      return Number(validPercent) >= 100 && nStatus === null ? 'success' : nStatus || 'normal';
    },
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          type = this.type,
          hideInfo = this.hideInfo,
          size = this.size,
          progressStatus = this.progressStatus;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(type === 'dashboard' ? 'circle' : type), true), _defineProperty(_ref, "".concat(prefixCls, "-show-info"), !hideInfo), _defineProperty(_ref, "".concat(prefixCls, "-status-").concat(progressStatus), true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(size), size), _ref;
    },
    lineStyle: function lineStyle() {
      var validPercent = this.validPercent,
          strokeWidth = this.strokeWidth,
          size = this.size,
          strokeColor = this.strokeColor,
          strokeLinecap = this.strokeLinecap;
      return {
        width: "".concat(validPercent, "%"),
        height: "".concat(strokeWidth || (size === 'small' ? 6 : 8), "px"),
        background: strokeColor,
        borderRadius: strokeLinecap === 'square' ? 0 : '50px'
      };
    },
    circleStyle: function circleStyle() {
      var width = this.width;
      var w = width || 120;
      return {
        width: "".concat(w, "px"),
        height: "".concat(w, "px"),
        fontSize: "".concat(w * 0.15 + 6, "px") //eslint-disable-line

      };
    },
    progressInfo: function progressInfo() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          hideInfo = this.hideInfo,
          type = this.type,
          progressStatus = this.progressStatus,
          format = this.format,
          validPercent = this.validPercent;

      if (hideInfo) {
        return null;
      }

      var formatFn = isFunction(format) ? format : defaultInfoFormat;
      var info = '';

      if (isFunction(format) || progressStatus !== 'success' && progressStatus !== 'exception') {
        info = formatFn(validPercent);
      } else {
        var iconType = progressStatus === 'success' ? 'ok' : 'close';
        iconType = type === 'line' ? "".concat(iconType, "_circle") : iconType;
        info = h(Icon, {
          "attrs": {
            "type": iconType
          }
        });
      }

      return h("span", {
        "class": "".concat(prefixCls, "-text")
      }, [info]);
    }
  },
  methods: {
    renderLine: function renderLine() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          progressInfo = this.progressInfo,
          lineStyle = this.lineStyle;
      return h("div", [h("div", {
        "class": "".concat(prefixCls, "-outer")
      }, [h("div", {
        "class": "".concat(prefixCls, "-inner")
      }, [h("div", {
        "class": "".concat(prefixCls, "-bg"),
        "style": lineStyle
      })])]), progressInfo]);
    },
    renderCircle: function renderCircle() {
      var h = this.$createElement;
      var $props = this.$props,
          prefixCls = this.prefixCls,
          circleStyle = this.circleStyle,
          type = this.type,
          gapPosition = this.gapPosition,
          gapDegree = this.gapDegree,
          strokeWidth = this.strokeWidth,
          validPercent = this.validPercent,
          progressInfo = this.progressInfo;
      var gapPos = gapPosition;
      var gapDeg = Number(gapDegree);
      gapDeg = !gapDeg || gapDeg < 0 ? 0 : gapDeg;

      if (type === 'dashboard') {
        if (!gapPos) {
          gapPos = 'bottom';
        }

        if (!gapDeg) {
          gapDeg = 75;
        }
      }

      var circleW = strokeWidth || 6;

      var props = _objectSpread({}, $props, {
        gapDegree: gapDeg,
        gapPosition: gapPos || 'top',
        strokeWidth: circleW,
        trailWidth: circleW,
        percentage: validPercent
      });

      return h("div", {
        "class": "".concat(prefixCls, "-inner"),
        "style": circleStyle
      }, [h(Circle, {
        "props": _objectSpread({}, props)
      }), progressInfo]);
    }
  },
  render: function render() {
    var h = arguments[0];
    var classes = this.classes,
        type = this.type,
        renderLine = this.renderLine,
        renderCircle = this.renderCircle;
    return h("div", {
      "class": classes
    }, [type === 'line' ? renderLine() : renderCircle()]);
  }
};